export default __webpack_public_path__ + "static/media/surfing.346bf630.svg";